import { createApi } from "@reduxjs/toolkit/query/react";
import CustomFetchBase from "../CustomFetchBase";

export const BotApi = createApi({
  reducerPath: "BotApi",
  baseQuery: CustomFetchBase,
  tagTypes: ["BOTS"],
  endpoints: (build) => ({
    getBots: build.query({
      query: ({ page = 1, limit = 20 } = {}) =>
        `/bots?page=${page}&limit=${limit}`,
      providesTags: ["BOTS"],
    }),

    getBotById: build.query({
      query: (id) => `/bots/${id}`,
      providesTags: ["BOTS"],
    }),

    createBot: build.mutation({
      query: (data) => ({
        url: `/bots`,
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["BOTS"],
    }),

    updateBot: build.mutation({
      query: ({ id, data }) => ({
        url: `/bots/${id}`,
        method: "PATCH",
        body: data,
      }),
      invalidatesTags: ["BOTS"],
    }),

    deleteBot: build.mutation({
      query: (id) => ({
        url: `/bots/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["BOTS"],
    }),

    deployBot: build.mutation({
      query: (id) => ({
        url: `/bots/${id}/deploy`,
        method: "POST",
      }),
      invalidatesTags: ["BOTS"],
    }),
  }),
});

export const {
  useGetBotsQuery,
  useGetBotByIdQuery,
  useCreateBotMutation,
  useUpdateBotMutation,
  useDeleteBotMutation,
  useDeployBotMutation,
} = BotApi;
